import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { DistanciaDeEntregaDTO } from '../../models/distancia-de-entrega.models';

@Injectable({
  providedIn: 'root',
})
export class DistanciaDeEntregaService {
  private baseUrl = '/distanciaDeEntrega';

  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<any> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;

    return this.apiService.read<any>(path);
  }

  getById<T>(url: string): Observable<any> {
    return this.apiService.read<any>(url);
  }

  post<T>(
    url: string,
    data: DistanciaDeEntregaDTO | undefined
  ): Observable<DistanciaDeEntregaDTO> {
    return this.apiService.create<DistanciaDeEntregaDTO>(url, data);
  }

  criar(distanciaDeEntrega: DistanciaDeEntregaDTO) {
    return this.apiService.create<any>(this.baseUrl, distanciaDeEntrega);
  }

  put<T>(
    url: string,
    data: DistanciaDeEntregaDTO
  ): Observable<DistanciaDeEntregaDTO> {
    return this.apiService.update<DistanciaDeEntregaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

}
